import { render, staticRenderFns } from "./MasterResourceList.vue?vue&type=template&id=152aecce&scoped=true"
import script from "./MasterResourceList.vue?vue&type=script&lang=js"
export * from "./MasterResourceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152aecce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('152aecce')) {
      api.createRecord('152aecce', component.options)
    } else {
      api.reload('152aecce', component.options)
    }
    module.hot.accept("./MasterResourceList.vue?vue&type=template&id=152aecce&scoped=true", function () {
      api.rerender('152aecce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/resourceManager/MasterResourceList.vue"
export default component.exports